export const snakeToCamelCase = (str: string): string =>
  str
    .split('_')
    .map((fragment: string, index: number) =>
      index === 0 ? fragment : (fragment[0] || '').toUpperCase() + fragment.slice(1),
    )
    .join('');
